// Library methods
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DefaultModal from "../DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../styles/muiStylesHelper";

const AdminModeModal = ({ open, onClose, onConfirm, onCancel }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("word_admin")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={onCancel}>
            {t("button_cancel")}
          </Button>
          <Button
            variant="outlined"
            sx={ModalCustomConfirm}
            onClick={onConfirm}
          >
            {t("word_proceed")}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        <Typography sx={{ fontWeight: "bold" }}>
          {t("admin_modal_manager")}:
        </Typography>
        <Grid display="flex" flexDirection="column" gap="8px">
          <Typography>{t("admin_modal_clinics_management")}</Typography>
          <Typography>{t("admin_modal_devices_management")}</Typography>
        </Grid>
      </Grid>
    </DefaultModal>
  );
};

export default AdminModeModal;
